import httpClient from "../http/http-client";
import { IAcceptRecommendationPayload, IAddActionToReportPeriod, ICreateReductionAction, IRecommendationsResponse, IReductionAction, IReductionActionForReportPeriod} from './reduction-action.model';

export default class ReductionActionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getReductionActions(queryParam?: string): Promise<IReductionAction[]> {
    return this.http.get(`reduction-action${queryParam ? queryParam : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getReductionAction(reductionActionId: string): Promise<IReductionAction> {
    return this.http.get(`reduction-action/${reductionActionId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** Ranked, rule-based recommendations for a reporting period, with reasons and saving ranges. */
  async getRecommendedReductionActions(reportPeriodId: string): Promise<IRecommendationsResponse> {
    return this.http.get(`reduction-action/recommendation?reportPeriodId=${reportPeriodId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  /** Adds a recommendation to the plan with the saving, basis and cost pre-filled (editable). */
  async acceptRecommendation(payload: IAcceptRecommendationPayload): Promise<{ message: string; reportPeriodReductionActionId: string }> {
    return this.http.post(`reduction-action/recommendation/accept`, payload)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }


  async addReductionActionToReportPeriod(action: IAddActionToReportPeriod): Promise<any>{
    return this.http.post(`reduction-action/add-action`, action)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async deleteReductionActionToReportPeriod(reductionActionId: string, reportPeriodId: string,): Promise<any> {
    return this.http.post(`reduction-action/delete-action`, { reductionActionId: reductionActionId, reportPeriodId: reportPeriodId, })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getAllReductionActionsForReportPeriod(queryString: string): Promise<IReductionActionForReportPeriod[]> {
    return this.http.get(`reduction-action/report-period?${queryString}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getAllReductionActionsForReportPeriodWithPagination(queryString: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{count: number, rows: IReductionActionForReportPeriod[]}> {
    return this.http.get(`reduction-action/report-period?${queryString}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getReportPeriodReductionAction(reductionActionId: string, queryString?: string): Promise<IReductionActionForReportPeriod> {
    const qs = queryString ? `?${queryString}` : '';
    return this.http.get(`reduction-action/report-period/${reductionActionId}${qs}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async editReductionActionForReportPeriod(reportPeriodReductionActionId: string, values: any): Promise<any> {
    return this.http.patch(`reduction-action/report-period/${reportPeriodReductionActionId}`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async createReductionAction(values: ICreateReductionAction): Promise<any> {
    return this.http.post(`reduction-action/create-action`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async editReductionAction(actionId: string, values: ICreateReductionAction): Promise<any> {
    return this.http.patch(`reduction-action/${actionId}/edit-action`, values)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}